import axios from 'axios';

export const authenticateBrowser = async (url, getFormData, bearer) => {
  return axios.post(
    url + 'authenticate/browser',
    {
      month: getFormData.expirationMonth,
      year: getFormData.expirationYear,
      amount: 2.95,
      currency: '978',
      challengeIndicator: '01',
      pan: getFormData.cardNumber,
      browser: {
        browserAcceptHeader: 'application/json',
        browserJavaEnabled: window.navigator.javaEnabled(),
        browserJavaScriptEnabled: true,
        browserLanguage: window.navigator.language,
        browserColorDepth: window.screen.colorDepth.toString(),
        browserScreenWidth: window.screen.width.toString(),
        browserScreenHeight: window.screen.height.toString(),
        browserTZ: new Date().getTimezoneOffset().toString(),
        browserUserAgent: window.navigator.userAgent,
      },
    },
    {
      headers: {
        accept: 'application/json',
        'x-3ds-api-key': '78a19f216d26440892cca3d031e62e20',
        'content-type': 'application/json',
        authorization: bearer,
      },
    }
  );
};
